import { getFiltersFromURL, updateURLWithFilters } from '@/utils';
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

export function useOrdersUrlSync({
  searchStore,
  filterStore,
  resetFilers,
}: {
  searchStore: any;
  filterStore: any;
  resetFilers: () => void;
}) {
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const filters = getFiltersFromURL(searchParams);

    // Search
    if (filters.search || filters.searchBy) {
      searchStore.setSearchValue({
        search: filters.search,
        searchBy: filters.searchBy,
      });
    } else {
      searchStore.setSearchValue({ search: null, searchBy: null });
    }

    //Page
    if (filters.page) {
      filterStore.setCurrentPage?.(filters.page);
    }

    // Filters
    if (filters.createdFrom && filters.createdTo) {
      filterStore.setCreatedAt?.({
        from: filters.createdFrom,
        to: filters.createdTo,
      });
    }
    if (filters.orderType) {
      filterStore.setOrderType?.(filters.orderType);
    }
    if (filters.carrier) {
      filterStore.setCarrier?.(filters.carrier);
    }
  }, []);
  useEffect(() => {
    if (!location.pathname.startsWith('/orders')) return;

    const filtersToSync = {
      search: searchStore.searchValue?.search,
      searchBy: searchStore.searchValue?.searchBy,
      createdFrom: filterStore.createdAtFilter?.from,
      createdTo: filterStore.createdAtFilter?.to,
      orderType: filterStore.orderTypeFilter,
      carrier: filterStore.carrierFilter,
      page: filterStore.currentPage,
    };

    const isSearchChanged = !!filtersToSync.search || !!filtersToSync.searchBy;
    const isFilterChanged =
      !!filtersToSync.createdFrom || !!filtersToSync.orderType || !!filtersToSync.carrier;

    updateURLWithFilters(setSearchParams, filtersToSync, {
      resetPage: isSearchChanged || isFilterChanged,
    });
  }, [
    location.pathname,
    searchStore.searchValue,
    filterStore.createdAtFilter,
    filterStore.orderTypeFilter,
    filterStore.carrierFilter,
    filterStore.currentPage,
  ]);

  useEffect(() => {
    return () => {
      if (!location.pathname.startsWith('/orders')) {
        searchStore.setSearchValue({ search: null, searchBy: null });
        resetFilers();
      }
    };
  }, [location.pathname]);
}
